<template>
  <div class="ui-upload-btn" @click.stop="_chooseFile">
    <i class="icon-add"></i>
    <span class="btn-text">{{ uploadBtnText }}</span>
    <!-- <input type="file" class="choose-file" @change="handleChooseFile" :multiple="multiple" :accept="accept" /> -->
  </div>
</template>

<script>
import { mapMutations } from "vuex"
import { FILE_TYPE_ERROR_MSG, FILE_SIZE_ERROR_MSG, FILE_TYPE_MAP, FILE_LENGTH_ERROR_MSG, FILE_SIZE_VIDEO_ERR_MSG } from "./dictionary"
import getRandomStr from "@/utils/getRandomStr"
import getVideoPoster from "@/utils/getVideoPoster"

const DEFAULT_POSTER = require("./images/default_poster.jpg")

export default {
  name: "uiUploadBtn",
  props: {
    fileTypeLimit: {
      type: [Array, Object],
      default() {
        return {
          image: ["jpeg", "jpg", "png", "webp", "bmp", "raw"],
          video: ["mp4", "avi", "flv", "rmvb", "mov"]
        }
      }
    },
    fileSizeLimit: {
      type: [Number, String, Object],
      default: 1000 * 1024 * 1024
    },
    multiple: {
      type: Boolean,
      default: true
    },
    fileTypeAccept: {
      type: Object,
      default() {
        return {
          image: "image/*",
          video: "video/*"
        }
      }
    },
    fileList: {
      type: Array,
      default() {
        return []
      }
    },
    limitLength: {
      type: [Number, String],
      default: ""
    },
    activityId: {
      type: [Number, String],
      default: ""
    },
    uploadFileType: {
      type: Array,
      default() {
        return ["image", "video"]
      }
    },
    fileTypeMap: {
      type: Object,
      default() {
        return {
          image: "图片",
          video: "视频"
        }
      }
    },
    errorTypeMsgTmp: {
      type: Object,
      default() {
        return {
          image: "该作品类型不支持上传[fileTypeName]",
          video: "该作品类型不支持上传[fileTypeName]",
          default: "该作品类型不支持上传该文件"
        }
      }
    },
    beforeChooseFile: {
      type: Function,
      default: null
    }
  },
  methods: {
    ...mapMutations({
      showToast: "toast/showToast"
    }),
    checkChooseFile(file) {
      if (!file.size) return false
      const fileType = file.type.split("/")[0]
      if (typeof this.fileSizeLimit === "object") {
        if (this.fileSizeLimit[fileType] && file.size / 1024 / 1024 > this.fileSizeLimit[fileType]) {
          const limitSize = `${this.fileSizeLimit[fileType]}MB`
          let errorMsg =
            fileType === "video" ? FILE_SIZE_VIDEO_ERR_MSG.replace("[size]", limitSize) : FILE_SIZE_ERROR_MSG.replace("[size]", limitSize)
          errorMsg = errorMsg.replace("[fileType]", FILE_TYPE_MAP[fileType])
          this.showToast(errorMsg)
          return false
        }
      } else if (this.fileSizeLimit && file.size / 1024 / 1024 > this.fileSizeLimit) {
        let errorMsg = FILE_SIZE_ERROR_MSG.replace("[size]", `${this.fileSizeLimit}MB`)
        errorMsg = errorMsg.replace("[fileType]", FILE_TYPE_MAP[fileType])
        this.showToast(errorMsg)
        return false
      }
      const fileSuffixBeginIndex = file.name.lastIndexOf(".")
      const fileSuffix = fileSuffixBeginIndex > -1 ? file.name.slice(fileSuffixBeginIndex + 1) : ""
      if (!this.fileLimit.includes(fileSuffix.toLowerCase())) {
        this.showToast(FILE_TYPE_ERROR_MSG)
        return false
      }
      return true
    },
    handleCheckFileLength(files) {
      let result = true
      if (this.limitLength) {
        result = this.fileList.length + files.length <= this.limitLength
      }
      if (!result) {
        const errMsg = FILE_LENGTH_ERROR_MSG.replace("[limitLength]", this.limitLength)
        this.showToast(errMsg)
      }
      return result
    },
    async handleChooseFile(e) {
      const files = e.target.files
      if (!this.handleCheckFileLength(files)) return
      let fileArr = []
      let passCheck = true
      for (let i = 0; i < files.length; i++) {
        const fileItem = files[i]
        if (this.checkFileLimit(fileItem) && this.checkChooseFile(fileItem)) {
          let fileType = fileItem.type.split("/")[0]
          const fileSuffixBeginIndex = fileItem.name.lastIndexOf(".")
          const fileSuffix = fileSuffixBeginIndex > -1 ? fileItem.name.slice(fileSuffixBeginIndex + 1) : ""
          if (!fileType) {
            fileType = this.fileTypeLimit.video.includes(fileSuffix) ? "video" : ""
          }
          let cover = DEFAULT_POSTER
          switch (fileType) {
            case "image":
              cover = window.URL.createObjectURL(fileItem)
              break
            case "video":
              cover = await getVideoPoster(window.URL.createObjectURL(fileItem))
          }
          const fileInfo = {
            file: fileItem,
            fileName: fileItem.name,
            fileSize: fileItem.size,
            fileType,
            cover,
            mediaId: "",
            key: fileItem.name + "_" + getRandomStr(),
            fileExt: fileSuffix
          }
          fileArr.push(fileInfo)
        } else {
          passCheck = false
          break
        }
      }
      if (passCheck) {
        try {
          this.$emit("chooseFile", fileArr)
        } catch (err) {
          window.console.error(err)
        }
      }
    },
    _chooseFile() {
      if (this.beforeChooseFile && typeof this.beforeChooseFile === "function") {
        const result = this.beforeChooseFile()
        if (!result) {
          return false
        }
      }
      let input = document.createElement("input")
      input.setAttribute("multiple", this.multiple)
      input.setAttribute("accept", this.accept)
      input.setAttribute("type", "file")
      input.style.position = "absolute"
      input.style.top = "-5000px"
      input.style.left = "-5000px"
      input.style.opacity = 0
      document.body.appendChild(input)
      const changeCb = e => {
        this.handleChooseFile(e)
        input.removeEventListener("change", changeCb)
        document.body.removeChild(input)
        input = null
      }
      input.addEventListener("change", changeCb)
      input.click()
    },
    checkFileLimit(fileItem) {
      const file = fileItem
      const fileType = file.type.split("/")[0]
      const isAllowFile = this.uploadFileType.includes(fileType)
      let result = true
      if (!isAllowFile) {
        result = false
        let errMsg = this.errorTypeMsgTmp[fileType] || this.errorTypeMsgTmp.default
        errMsg = errMsg.replace("[fileTypeName]", this.fileTypeMap[fileType])
        this.showToast(errMsg)
      }
      return result
    }
  },
  computed: {
    fileLimit() {
      return this.uploadFileType
        .map(fileType => this.fileTypeLimit[fileType])
        .toString()
        .split(",")
    },
    uploadBtnText() {
      return this.uploadFileType.map(fileType => this.fileTypeMap[fileType]).join("/")
    },
    accept() {
      return this.uploadFileType.length > 1 ? "" : this.fileTypeAccept[this.uploadFileType[0]] || ""
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-upload-btn {
  background: #f7f7f7;
  border: 1px solid #dddddd;
  border-radius: 0.05rem;
  width: 1.54rem;
  height: 1.54rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  .icon-add {
    margin-bottom: 0.24rem;
    width: 0.36rem;
    height: 0.36rem;
    background: url("../../assets/images/reportpage_pic_icon_add.png") no-repeat center;
    background-size: 100%;
  }
  .btn-text {
    font-family: PingFangSC-Regular;
    font-size: 0.24rem;
    color: #666666;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.34rem;
  }
  .choose-file {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
}
</style>
